import { useState } from 'react';
import type { SourceResult } from '../types';
import { HudFrame } from './HudFrame';

export function SourcesPanel({ sources }: { sources: SourceResult[] }) {
  const [open, setOpen] = useState<string | null>(null);

  if (!sources.length) {
    return (
      <HudFrame title="SOURCES" code="SRC-00" status="idle">
        <p className="empty">No source results yet.</p>
      </HudFrame>
    );
  }

  const ok = sources.filter((s) => s.status === 'ok').length;

  return (
    <HudFrame title="SOURCES" code="SRC-01" status="live" meta={`${ok}/${sources.length} OK`}>
      <ul className="src-list">
        {sources.map((s) => (
          <li key={s.id} className={`src src--${s.status}`}>
            <button
              type="button"
              className="src__head"
              onClick={() => setOpen(open === s.id ? null : s.id)}
            >
              <span className={`src__dot src__dot--${s.status}`} />
              <span className="src__label">{s.label}</span>
              <span className="src__id">{s.id}</span>
              <span className="src__ms">{s.durationMs}ms</span>
              <span className="src__status">{s.status}</span>
            </button>
            {open === s.id && (
              <div className="src__body">
                {s.note && <p className="src__note">{s.note}</p>}
                {s.error && <p className="src__err">{s.error}</p>}
                {s.data != null && (
                  <pre className="src__json">{JSON.stringify(s.data, null, 2)}</pre>
                )}
              </div>
            )}
          </li>
        ))}
      </ul>
    </HudFrame>
  );
}
